import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20beautiful%20artistic%20Korean%20manhwa%20style%20illustration%20of%20a%20dreamy%20night%20sky%20with%20soft%20stars%2C%20floating%20cherry%20blossom%20petals%2C%20a%20warm%20glowing%20moon%2C%20silhouette%20of%20a%20couple%20sitting%20on%20a%20hill%20reading%20together%2C%20soft%20pastel%20gradients%2C%20romantic%20atmosphere%2C%20whimsical%20fantasy%20vibe%2C%20clean%20minimal%20composition&width=1920&height=1080&seq=hero-bg-yy-01&orientation=landscape"
        alt="yy漫画网 - 韩漫免费在线阅读"
        title="yy漫画网 - 韩漫免费在线阅读平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/50"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center px-4 w-full max-w-4xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 mb-4 leading-tight">
            韩漫免费漫画在线<span className="text-accent-400">下拉式阅读</span>
          </h1>
          <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
            yy漫画网为您提供免费韩漫资源，支持在线下拉式阅读，涵盖丰富韩国漫画题材
            <br className="hidden md:block" />
            让您轻松浏览精彩故事，无需付费即可开始阅读
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/romance"
              className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-book-open-line"></i>
              开始阅读
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-8 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm font-semibold hover:bg-background-50/25 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-information-line"></i>
              了解更多
            </Link>
          </div>
          <div className="flex items-center justify-center gap-6 mt-10">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-accent-400">12+</div>
              <div className="text-xs text-background-300 mt-1">漫画分类</div>
            </div>
            <div className="w-px h-8 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-accent-400">1000+</div>
              <div className="text-xs text-background-300 mt-1">漫画资源</div>
            </div>
            <div className="w-px h-8 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-accent-400">50万+</div>
              <div className="text-xs text-background-300 mt-1">每日访问</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}